import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import StatusInfoCard from "./StatusInfoCard";
import { getControlPannelTitle, getLogValueDescByCodeAndValue } from "data/data";
import CircleChart from "components/inner/chart/CircleChart";

const SubOperationCard = ({ data }) => {
    const { t } = useTranslation();
    if (!data) return null;

    // Helper to figure out both the component content and card type in one pass
    const getContentAndType = () => {
        if (!data.logUnit) {
            const result = getLogValueDescByCodeAndValue(
                "icon",
                data.logCode,
                data.logValue,
                data.equipmentPartCode,
                data.componentLocationCode
            );

            if (result.kind === "icon") {
                return {
                    fontSize: '30px',
                    cardType: 'charts_circle',
                    content: (
                        <img
                            src={`${process.env.PUBLIC_URL}/img/icon/${result.value}.png`}
                            alt=""
                        />
                    )
                };
            }

            return {
                fontSize: '30px',
                cardType: 'charts_text',
                content: <>{t(result.value)}</>
            };
        }

        if (data.logUnit === '%') {
            return {
                fontSize: '24px',
                cardType: '', // Note: change to 'charts_circle' if your percentage gauge needs circle styling
                content: (
                    <CircleChart
                        angleType="gauge"
                        viewType="temp"
                        optionData={[
                            {
                                name: data.logName,
                                value: data.logValue || 0,
                            },
                        ]}
                        width="110px"
                        height="110px"
                    />
                )
            };
        }

        return {
            fontSize: '24px',
            cardType: 'charts_text',
            content: `${data.logValue} ${data.logUnit}`
        };
    };

    const { fontSize, cardType, content } = getContentAndType();

    return (
    <StatusInfoCard title={`${getControlPannelTitle(data)}`} cardType={cardType}>
        <Box
            sx={{
                borderRadius: 2,
                p: 1.5,
                boxSizing: "border-box",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize
                }}
                className="no_circle"
            >
                {content}
            </Box>
        </Box>
    </StatusInfoCard>
    );
}

export default SubOperationCard;